import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import productData from '../data/productData';
import '../styles/Products.css';

const Products = () => {
  return (
    <main className="products-page">
      <SEO
        title="Products & Shopify Apps | Bularis Tech"
        description="Explore Shopify apps and software products built by Bularis Tech, including payment customization and product-to-variant widget mapping."
        path="/products"
      />
      <header className="products-header">
        <span className="products-eyebrow">Built by Bularis Tech</span>
        <h1>Products &amp; Apps</h1>
        <p>
          Explore practical applications developed to give businesses more control over their
          digital operations and customer experiences.
        </p>
      </header>

      <section className="products-grid" aria-label="Bularis Tech products and apps">
        {productData.map((product) => (
          <article className="product-card" key={product.id}>
            <span className="product-type">{product.type}</span>
            <h2>{product.title}</h2>
            <p>{product.summary}</p>
            <Link to={product.path}>View app details <span aria-hidden="true">→</span></Link>
          </article>
        ))}
      </section>
    </main>
  );
};

export default Products;
